import { useEffect, useRef, useState } from "react";
import styles from "./MultiSelectDropdown.module.css";
import { useDispatch, useSelector } from "react-redux";
import { applyFilters } from "../../store/slices/FilterSliceManpowerDealerReview";
import { Loader } from "rsuite";

function ViMultiSelectDropdown({
  options = [],
  onSelectionChange,
  opnsSelected,
  keey,
  isLoading,
}) {
  const { data } = useSelector((state) => state.filtersManpowerDealerReview);
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const dropdownRef = useRef(null);

  // Update filtered options when options change
  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  // Update selected options when opnsSelected changes
  useEffect(() => {
    if (opnsSelected?.length > 0) {
      setSelectedOptions(opnsSelected);
    } else {
      setSelectedOptions(options);
    }
  }, [opnsSelected, options]);

  // Handle clicks outside the dropdown
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const toggleOption = (e) => {
    const option = e.target.value;
    const isChecked = e.target.checked;

    setSelectedOptions((prevSelected) => {
      if (isChecked) {
        return [...prevSelected, option];
      } else {
        return prevSelected.filter((item) => item !== option);
      }
    });
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleApply = () => {
    const updatedData = { ...data, [keey]: selectedOptions };
    dispatch(applyFilters(updatedData));
    onSelectionChange(selectedOptions);
    setIsOpen(false);
  };

  const toggleSelectAll = () => {
    if (selectedOptions.length < filteredOptions.length) {
      setSelectedOptions(filteredOptions);
    } else {
      setSelectedOptions([]);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setFilteredOptions(
      options.filter((option) =>
        option.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  return (
    <div className={styles.dropdownContainer} ref={dropdownRef}>
      <button
        className={styles.dropdownButton}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {isLoading ? (
          <Loader />
        ) : selectedOptions.length === 1 ? (
          selectedOptions[0]
        ) : selectedOptions.length > 1 ? (
          `Selected (${selectedOptions.length})`
        ) : (
          "Select Options"
        )}
      </button>

      {isOpen && (
        <div className={styles.dropdownMenu}>
          <div className={styles.dropdownContents}>
            <input
              type="text"
              id="search-dropdown"
              name="search-dropdown"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
              className={styles.dropdownSearch}
            />

            <label className={styles.dropdownItem}>
              <input
                type="checkbox"
                id="select-all"
                name="select-all"
                checked={selectedOptions.length === filteredOptions.length}
                onChange={toggleSelectAll}
              />
              <span>Select All</span>
            </label>

            {filteredOptions.map((option) => (
              <label key={option} className={styles.dropdownItem}>
                <input
                  type="checkbox"
                  id={`option-${option}`}
                  name={`option-${option}`}
                  checked={selectedOptions.includes(option)}
                  onChange={(e) => toggleOption(e)}
                  value={option}
                />
                <span>{option}</span>
              </label>
            ))}

            <div className={styles.dropdownActions}>
              <button className={styles.cancelButton} onClick={handleCancel}>
                Cancel
              </button>
              <button className={styles.applyButton} onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViMultiSelectDropdown;
